import React from 'react'
import PropTypes from 'prop-types'

import Icon from '../../../Shared/Icon/Icon'

import Thumbnails from './Thumbnails'
import EmptyLoader from './EmptyLoader'

function ThumbnailsContainer({
  images, selectedImages, mainImageId, preloaders, onChangeMainImage, removeSelectedImages, onCheckboxChange, loaderIcon, showError,
}) {
  const firstImage = images[0]

  return (
    <div className="uploaded-images">
      <div className="uploaded-images__top">
        {images.length > 1
          && (
          <button
            className="btn btn-sm btn-transparent btn-primary"
            onClick={() => onChangeMainImage()}
            disabled={selectedImages.length !== 1}
          >
            Main image
            <Icon type={['far', 'image']} className="ml-5" />
          </button>
          )
        }
        {selectedImages.length > 0
          && (
          <button className="btn btn-sm btn-transparent btn-primary" onClick={() => removeSelectedImages()}>
            Delete
            <Icon type={['far', 'times']} className="ml-5" />
          </button>
          )
        }
      </div>

      {images.length > 0 || preloaders.length > 0
        ? images.map((image) => (
          <Thumbnails
            key={image.id}
            id={image.id}
            image={image}
            onCheckboxChange={onCheckboxChange}
            mainImageId={mainImageId === null ? firstImage.id : mainImageId}
          />
        )) : showError === true
          && (
          <div className="form-group">
            <div className="error-message">
              <span className="text">You have to upload at least one image.</span>
            </div>
          </div>
          )
      }
      {preloaders.map((preloader, index) => <EmptyLoader key={index} loaderIcon={loaderIcon} />)}
    </div>
  )
}

ThumbnailsContainer.propTypes = {
  images: PropTypes.array.isRequired,
  selectedImages: PropTypes.array.isRequired,
  mainImageId: PropTypes.number,
  preloaders: PropTypes.array.isRequired,
  onChangeMainImage: PropTypes.func.isRequired,
  removeSelectedImages: PropTypes.func.isRequired,
  onCheckboxChange: PropTypes.func.isRequired,
  loaderIcon: PropTypes.string.isRequired,
  showError: PropTypes.bool.isRequired,
}

export default ThumbnailsContainer
